// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DjschoolLessonController from "./djschool_lesson_controller"
application.register("djschool-lesson", DjschoolLessonController)

import DjschoolProgressController from "./djschool_progress_controller"
application.register("djschool-progress", DjschoolProgressController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import HardwareController from "./hardware_controller"
application.register("hardware", HardwareController)

import ScrolltotopController from "./scrolltotop_controller"
application.register("scrolltotop", ScrolltotopController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TrixYoutubeAttachmentController from "./trix_youtube_attachment_controller"
application.register("trix-youtube-attachment", TrixYoutubeAttachmentController)

import VoucherResourceController from "./voucher_resource_controller"
application.register("voucher-resource", VoucherResourceController)
